import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import style from "./style/menu.module.scss";
import { menuData } from "./utils";
import { selectCardContent, selectSubcategory } from "../../store/Slices/menuContent";
import { useLocation } from "react-router-dom";

const Menu = ({ onClick }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const [openMenu, setOpenMenu] = useState(null);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const toggleMobileMenu = (e) => {
        e.stopPropagation();
        setMobileMenuOpen(prev => !prev);
        setOpenMenu(null);
    };

    const onMenuItemClick = (id, subcategories, path) => {
        dispatch(selectSubcategory({
            menuId: id,
            subcategory: subcategories?.length ? subcategories[0] : null
        }));
        dispatch(selectCardContent(null));
        if (path && path !== location.pathname) {
            navigate(path);
        }
        setMobileMenuOpen(false);
    };

    const onSubItemClick = (e, id, sub, path) => {
        e.stopPropagation();
        dispatch(selectSubcategory({
            menuId: id,
            subcategory: sub
        }));
        dispatch(selectCardContent(null));
        if (path && path !== location.pathname) {
            navigate(path);
        }
        setMobileMenuOpen(false);
    };

    return (
        <nav className={style.boxes} onClick={onClick}>

            <button
                className={style.hamburger}
                onClick={toggleMobileMenu}
                aria-label="Toggle menu"
                type="button"
            >
                &#9776;
            </button>

            <ul className={`${style.menu} ${mobileMenuOpen ? style.mobileOpen : ''}`}>
                {menuData.map(({ id, name, subcategories, path }) => (
                    <li
                        key={id + name}
                        className={style.list}
                        onMouseEnter={() => window.innerWidth > 768 && subcategories && setOpenMenu(id)}
                        onMouseLeave={() => window.innerWidth > 768 && setOpenMenu(null)}
                        onClick={() => onMenuItemClick(id, subcategories, path)}
                    >
                        {name}

                        {openMenu === id && subcategories && window.innerWidth > 768 && (
                            <ul className={style.submenu}>
                                {subcategories.map((sub, index) => (
                                    <li
                                        key={index + name}
                                        onClick={(e) => onSubItemClick(e, id, sub, path)}
                                    >
                                        {sub}
                                    </li>
                                ))}
                            </ul>
                        )}


                        {mobileMenuOpen && openMenu === id && subcategories && window.innerWidth <= 768 && (
                            <ul className={style.submenu}>
                                {subcategories.map((sub, index) => (
                                    <li
                                        key={index + name}
                                        onClick={(e) => onSubItemClick(e, id, sub, path)}
                                    >
                                        {sub}
                                    </li>
                                ))}
                            </ul>
                        )}


                        {mobileMenuOpen && window.innerWidth <= 768 && (
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (openMenu === id) {
                                        setOpenMenu(null);
                                    } else if (subcategories) {
                                        setOpenMenu(id);
                                    }
                                }}
                                style={{ cursor: subcategories ? "pointer" : "default", fontSize: 12, color: "#666" }}
                            >
                                {subcategories ? (openMenu === id ? "▲ Փակել" : "▼ Բացել ենթաբաժինը") : null}
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Menu;
